/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Peter Njagi',
        title: 'Business Consultant',
        text: "Working with Ian Kinuthia was an absolute pleasure. Their expertise in web development transformed our online presence. The website they created not only looks fantastic but also functions seamlessly. Ian Kinuthia was responsive, creative, and incredibly professional throughout the entire process. We highly recommend their services!",
        image: boy2
    },
    {
        id: 2,
        name: 'Rachael Njeri',
        title: 'CEO, Zurita',
        text: "Ian Kinuthia exceeded our expectations in every way. They took our vision and turned it into a reality, creating a website that perfectly represents our brand. Their attention to detail and commitment to delivering a high-quality product is commendable. We're thrilled with the results!",
        image: girl2
    },
    {
        id: 3,
        name: 'James Githinji',
        title: 'Massuese',
        text: "We couldn't be happier with the website Ian Kinuthia built for us. They were able to capture the essence of our business and translate it into an engaging and user-friendly site. Their technical skills are top-notch, and their dedication to customer satisfaction is evident in every interaction. We're grateful for their contribution to our online success.",
        image: girl1
    },
    {
        id: 4,
        name: 'Henri Naykundi',
        title: 'CEO, a-r-e-d',
        text: "I can't speak highly enough of Ian Kinuthia. Their ability to take our ideas and turn them into a functional, visually appealing website was remarkable. Their communication skills, technical knowledge, and dedication to excellence set them apart. We now have a website that truly represents our business and meets the needs of our customers.",
        image: boy1
    },
    {
        id: 5,
        name: 'Linet Achieng',
        title: 'Sales Executive',
        text: 'Our experience working with Ian Kinuthia was outstanding. They designed and developed a website that perfectly represents our brand and business. Their attention to detail and responsiveness to our requests made the entire process smooth and enjoyable. We highly recommend Ian Kinuthia to anyone looking for a web developer who truly cares about their clients success.',
        image: girl3
    },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

